import { DataTableColumnHeader } from "../table-components/data-table-column-header";

export const requestStatusColumns = [
    {
        id: "isRequestedForCancel",
        header: ({ column }) => (
            <DataTableColumnHeader column={column} title="Requested For Cancel" />
        ),
        accessorFn: (row) => (row.isRequestedForCancel ? "Yes" : "No"),
        cell: ({ row }) => {
            const isRequested = row.original.isRequestedForCancel;
            return (
                <span
                    className={`px-2 py-1 text-xs rounded ${isRequested
                            ? "bg-red-100 text-red-800"
                            : "bg-gray-100 text-gray-800"
                        }`}
                >
                    {isRequested ? "Yes" : "No"}
                </span>
            );
        },
    },
    {
        id: "isRequestedForVolunteer",
        header: ({ column }) => (
            <DataTableColumnHeader column={column} title="Requested For Volunteer" />
        ),
        accessorFn: (row) => (row.isRequestedForVolunteer ? "Yes" : "No"),
        cell: ({ row }) => {
            const isRequested = row.original.isRequestedForVolunteer;
            return (
                <span
                    className={`px-2 py-1 text-xs rounded ${isRequested
                            ? "bg-blue-100 text-blue-800"
                            : "bg-gray-100 text-gray-800"
                        }`}
                >
                    {isRequested ? "Yes" : "No"}
                </span>
            );
        },
    },
];
